module.exports = __webpack_public_path__ + "static/media/saving-ico.de148a40.svg";